import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "How do I book a transfer?", a: "Simply enter your pick-up and drop-off locations in our booking form, select the number of passengers, and click Search. You'll see available vehicles with transparent pricing." },
  { q: "Do you offer airport transfers?", a: "Yes! We provide transfers to and from all major airports in the Dominican Republic including Punta Cana (PUJ), Santo Domingo (SDQ), and Puerto Plata (POP)." },
  { q: "Can I cancel or modify my booking?", a: "Yes, you can cancel or modify your booking up to 24 hours before your scheduled pickup time for a full refund." },
  { q: "What payment methods do you accept?", a: "We accept credit cards, PayPal, and cash payments. All online payments are processed securely." },
  { q: "Are your drivers bilingual?", a: "Yes, all our drivers speak both English and Spanish to ensure clear communication with all travelers." },
  { q: "Do you provide child seats?", a: "Yes, child seats are available upon request at no additional cost. Please mention this in your booking notes." },
];

const FAQSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="text-secondary font-semibold text-sm uppercase tracking-widest">FAQ</span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mt-2">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-border/50 rounded-none bg-white px-5"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-foreground hover:text-secondary py-4">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-4">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
